<template>
	<div class="layout">
		<div class="layout__header">
			<div class="layout__title">
				<h3>Zona geográfica</h3>
			</div>
		</div>
		<div class="layout__main">
			<div class="layout__main-form">
				<div class="card">
					<div class="card__content">
						<div class="row">
							<div class="col-xs-12 col-md-6">
								<input-field @input="inputCodigoPais" v-model="form.pais_id" id="pais_id" placeholder="Código del país...">
									Código del país
									<span v-if="errores.pais_id" class="helper-text text-danger" slot="helper">
										<strong>{{ errores.pais_id[0] }}</strong>
									</span>
								</input-field>
							</div>
							<div class="col-xs-12 col-md-6">
								<input-field v-model="form.descripcion" id="descripcion" placeholder="Nombre del país...">
									Nombre de país
									<span v-if="errores.descripcion" class="helper-text text-danger" slot="helper">
										<strong>{{ errores.descripcion[0] }}</strong>
									</span>
								</input-field>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-xs-12 col-md-6 mt-2">
						<details class="card card--collapsible" open>
							<summary class="card__title card__title--bg-primary">
								<h5>Provincias / Estados</h5>
							</summary>
							<div class="card__content">
								<div class="row">
									<div class="col-xs-12">
										<button v-if="crear" :disabled="!crearProvincia" @click="abrirProvincia" tooltip="Agregar provincia/estado" class="btn-success" type="button">
											<i class="fa fa-plus"></i>
										</button>
									</div>
									<div class="col-xs-12 mt-2">
										<div class="table-responsive">
											<vue-good-table
												:columns="[
													{
														label: 'Código',
														field: 'id_provincia'
													},
													{
														label: 'Nombre',
														field: 'descripcion'
													},
													{
														label: 'País',
														field: 'pais.nombre'
													},
													{
														label: 'acciones',
														field: 'acciones'
													}
												]"
												:pagination-options="{
													enabled: false,
													perPage: 10,
													nextLabel: 'siguiente',
													prevLabel: 'anterior',
													rowsPerPageLabel: 'Registros por página',
													ofLabel: 'de',
													allLabel: 'Todo',
													dropdownAllowAll: true
												}"
												ref="listaProvincia"
												:rows="provincias"
												:search-options="{
													enabled: true,
													placeholder: 'Buscar...'
												}"
												styleClass="vgt-table vgt-table--sticky"
												@on-row-click="verCiudades"
											>
												<template slot="table-column" slot-scope="props">
													<span v-if="props.column.label =='acciones'">
														Acciones
													</span>
													<span v-else>
														{{props.column.label}}
													</span>
												</template>
												<template slot="table-row" slot-scope="props">
													<span v-if="props.column.field == 'acciones'">
														<button v-if="editar" @click="editarProvincia(props.row)" tooltip="Editar provincia/estado" class="btn-info" type="button">
															<i class="fa fa-edit"></i>
														</button>
														<button v-if="eliminar" @click="eliminarProvincia(props.row)" tooltip="Eliminar provincia/estado" class="btn-danger" type="button">
															<i class="fa fa-trash"></i>
														</button>
													</span>
													<span v-else>
														{{ props.formattedRow[props.column.field] }}
													</span>
												</template>
											</vue-good-table>
										</div>
									</div>
								</div>
							</div>
						</details>
					</div>
					<div class="col-xs-12 col-md-6 mt-2">
						<details class="card card--collapsible" open>
							<summary class="card__title card__title--bg-primary">
								<h5>{{ nombre_provincia != '' && nombre_provincia != null?`Ciudades de la provincia / estado de  ${nombre_provincia}`:'Ciudades' }}</h5>
							</summary>
							<div class="card__content">
								<div class="row">
									<div class="col-xs-12">
										<button v-if="crear" :disabled="provincias.length == 0" @click="abrirCiudad" tooltip="Agregar ciudad" class="btn-success" type="button">
											<i class="fa fa-plus"></i>
										</button>
									</div>
									<div class="col-xs-12 mt-2">
										<div class="table-responsive">
											<vue-good-table
												:columns="[
													{
														label: 'Código',
														field: 'id_ciudad'
													},
													{
														label: 'Nombre',
														field: 'descripcion'
													},
													{
														label: 'Provincia/Estado',
														field: 'provincia.nombre'
													},
													{
														label: 'País',
														field: 'provincia.pais.nombre'
													},
													{
														label: 'acciones',
														field: 'acciones'
													}
												]"
												:pagination-options="{
													enabled: false,
													perPage: 10,
													nextLabel: 'siguiente',
													prevLabel: 'anterior',
													rowsPerPageLabel: 'Registros por página',
													ofLabel: 'de',
													allLabel: 'Todo',
													dropdownAllowAll: true
												}"
												ref="listaCiudad"
												:rows="ciudades"
												:search-options="{
													enabled: true,
													placeholder: 'Buscar...'
												}"
												styleClass="vgt-table vgt-table--sticky"
											>
												<template slot="table-column" slot-scope="props">
													<span v-if="props.column.label =='acciones'">
														Acciones
													</span>
													<span v-else>
														{{props.column.label}}
													</span>
												</template>
												<template slot="table-row" slot-scope="props">
													<span v-if="props.column.field == 'acciones'">
														<button v-if="editar" @click="editarCiudad(props.row)" tooltip="Editar ciudad" class="btn-info" type="button">
															<i class="fa fa-edit"></i>
														</button>
														<button v-if="eliminar" @click="eliminarCiudad(props.row)" tooltip="Eliminar ciudad" class="btn-danger" type="button">
															<i class="fa fa-trash"></i>
														</button>
													</span>
													<span v-else>
														{{ props.formattedRow[props.column.field] }}
													</span>
												</template>
											</vue-good-table>
										</div>
									</div>
								</div>
							</div>
						</details>
					</div>
				</div>
			</div>
			<div class="layout__main-buttons">
				<div class="card">
					<div class="card__content">
						<button v-if="crear" @click="botonGuardar" class="btn-success"><i class="fa fa-save"></i><span>Guardar</span></button>
						<button @click="botonLimpiar" class="btn-primary btn--text"><i class="fa fa-refresh"></i><span>Limpiar</span></button>
					</div>
				</div>
			</div>
		</div>
		<modal :scrollable="true" :clickToClose="false" :width="'80%'" height="auto" name="provincia">
			<provincia :propProvincia="provincia" :paisId="form.pais_id" @cargarProvincia="cargarProvincia"/>
		</modal>
		<modal :scrollable="true" :clickToClose="false" :width="'80%'" height="auto" name="ciudad">
			<ciudad :propCiudad="ciudad" :paisId="form.pais_id" :provinciaId="provincia_id" @cargarCiudad="cargarCiudad"/>
		</modal>
	</div>
</template>
<script>
export default {
	props:{
		consultar: {
			type: Boolean,
			required: false,
		},
		crear: {
			type: Boolean,
			required: false,
		},
		editar: {
			type: Boolean,
			required: false,
		},
		eliminar: {
			type: Boolean,
			required: false,
		},
	},
	data() {
		return {
			crearProvincia: false,
			provincia_id: '',
			nombre_provincia: '',
			provincias: [],
			ciudades: [],
			selectedIndex: -1,
			form: {
				pais_id: '',
				descripcion: '',
			},
			errores: {},
			provincia: null,
			ciudad: null,
		}
	},
	methods: {
		cargarCiudad: function(row, pais = null){
			if(this.selectedIndex == -1){
				this.ciudades.unshift(row);
			}
			else
				this.ciudades.splice(this.selectedIndex, 1, row);
			if(pais != null){
				this.form.pais_id = pais.id_pais;
				this.form.descripcion = pais.descripcion;
				this.provincias = [...pais.provincias];
			}
		},
		editarCiudad: function(row){
			this.selectedIndex = this.$refs.listaCiudad.filteredRows[0].children.indexOf(row);
			this.ciudad = row;
			this.$modal.show('ciudad');
		},
		abrirCiudad: function(){
			this.ciudad = null;
			this.selectedIndex = -1;
			this.$modal.show('ciudad');
		},
		abrirProvincia: function(){
			this.provincia = null;
			this.selectedIndex = -1;
			this.$modal.show('provincia');
		},
		verCiudades: function(params){
			let row = params.row;
			this.nombre_provincia = '';
			this.ciudades.splice(0, this.ciudades.splice(0, this.ciudades.length));
			if(row != null && row.ciudades != null){
				this.provincia_id = row.id_provincia;
				this.nombre_provincia = row.descripcion;
				this.ciudades = [...row.ciudades];
			}
		},
		cargarProvincia: function(row){
			if(this.selectedIndex == -1)
				this.provincias.unshift(row);
			else
				this.provincias.splice(this.selectedIndex, 1, row);
		},
		editarProvincia: function(row){
			this.selectedIndex = this.$refs.listaProvincia.filteredRows[0].children.indexOf(row);
			this.provincia = row;
			this.$modal.show('provincia');
		},
		eliminarProvincia: function(row){
			this.selectedIndex = this.$refs.listaProvincia.filteredRows[0].children.indexOf(row);
			swal.fire({
					title: `¿Desea eliminar el Provincia/Estado ${row.nombre}?`,
					text: "Esta acción requiere de confirmación.",
					type: 'question',
					showCancelButton: true,
					confirmButtonText:'Aceptar'
			}).then((result) => {
					if (result.value) {
						axios.delete(url+ '/zona-geografica/eliminar-provincia/'+row.id_provincia).then(response => {
							let data = response.data;
							if(data.error){
								swal.fire('Aviso', data.mensaje, 'warning');
								return;
							}
							swal.fire('Eliminado', 'La provincia/estado ha sido eleminado(a).', 'success');
							this.provincias.splice(this.selectedIndex, 1);
							this.selectedIndex = -1;
						}).catch(error => {
						if (error !== undefined && error !== null) {
							let response = error.response;
							if (response !== undefined && response !== null) {
									if(response.data.message != null && response.data.message != '')
										swal.fire('Error', response.data.message, 'error');
									else
										swal.fire("Hubo un error, intente nuevamente.", "Error", "error");
								}
							}
						});
					}
			});
		},
		eliminarCiudad: function(row){
			this.selectedIndex = this.$refs.listaCiudad.filteredRows[0].children.indexOf(row);
			swal.fire({
					title: `¿Desea eliminar la Ciudad ${row.nombre}?`,
					text: "Esta acción requiere de confirmación.",
					type: 'question',
					showCancelButton: true,
					confirmButtonText:'Aceptar'
			}).then((result) => {
					if (result.value) {
						axios.post(url+ '/zona-geografica/eliminar-ciudad/'+row.id_ciudad, row).then(response => {
							let data = response.data;
							if(data.pais != null){
								this.form.pais_id = data.pais.id_pais;
								this.form.descripcion = data.pais.descripcion;
								this.provincias = [...data.pais.provincias];
							}
							this.ciudades.splice(this.selectedIndex, 1);
							this.selectedIndex = -1;
							swal.fire('Eliminado', 'La ciudad ha sido eleminado(a).', 'success');
						}).catch(error => {
						if (error !== undefined && error !== null) {
							let response = error.response;
							if (response !== undefined && response !== null) {
									if(response.data.message != null && response.data.message != '')
										swal.fire('Error', response.data.message, 'error');
									else
										swal.fire("Hubo un error, intente nuevamente.", "Error", "error");
								}
							}
						});
					}
			});
		},
		botonGuardar: function(){
			swal.fire({
				title: '¿Deseas guardar el País?',
				text: "Esta acción requiere de confirmación.",
				type: 'question',
				showCancelButton: true,
				confirmButtonText:'Aceptar'
		}).then((result) => {
				if (result.value) {
					axios.post(url+ '/zona-geografica/guardar-pais', this.form).then(response => {
						this.limpiarErrores();
						swal.fire('Almacenado', 'Se ha almacenado satisfactoriamente.', 'success');
					}).catch(error => {
						if (error !== undefined && error !== null) {
							let response = error.response;
							if (response !== undefined && response !== null) {
								let status = response.status;
								if (status === 422) {
									this.errores = response.data.errors;
									swal.fire("Hay validaciones por corregir.", "Aviso", "warning");
								} else{
										if(response.data.message != null && response.data.message != '')
											swal.fire('Error', response.data.message, 'error');
										else
											swal.fire("Hubo un error, intente nuevamente.", "Error", "error");
									}
							}
						}
					});
				}
			});
		},
		botonLimpiar: function(){
			this.form.pais_id = '';
			this.limpiar();
			this.limpiarErrores();
		},
		limpiarErrores: function(){
			this.errores = {};
		},
		limpiar: function(){
			this.crearProvincia = false;
			this.selectedIndex = -1;
			this.form.descripcion = '';
			this.provincia_id = '';
			this.nombre_provincia = '';
			this.ciudades.splice(0, this.ciudades.length);
			this.provincias.splice(0, this.provincias.length);
			this.ciudad = null;
			this.provincia = null;
			this.limpiarErrores();
		},
		inputCodigoPais: function(value){
        this.searchingCodigoPais(value, this);
		},
		searchingCodigoPais: _.debounce((search, vm) => {
			fetch(`${url}/zona-geografica/search-codigo-pais?search=${search}`)
				.then((response) => response.json())
				.then((data) => {
					vm.limpiar();
					if(data != null){
						vm.ciudades.splice(0, vm.ciudades.length);
						vm.form.descripcion = data.descripcion;
						vm.provincias = [...data.provincias];
						vm.crearProvincia = true;
					}
				}).catch(console.error);
    }, 320),
	},
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/mantenimiento/zona-geografica/ZonaGeografica.vue